import { gql } from "@apollo/client";
import { UVDRobotIcon } from "assets/icons/UVDRobotIcon";
import { MenuItem } from "components/atoms/dashboard/menuItems/MenuItem";
import { MenuTitle } from "components/atoms/dashboard/menuItems/MenuTitle";
import { IoGridOutline } from "react-icons/io5";
import { NavLink } from "react-router-dom";
import { useQueryWithSnack } from "utils/useQueryWithSnack";
import {
  Affiliation,
  Organization,
  RobotAffiliation,
  RoleType,
} from "../../../gql/graphql";

const ORG_MENUITEMS_QUERY = gql`
  query YourMenuItems($filter: FilterOrganizationsPayload) {
    organizations(filter: $filter) {
      name
      robotAffiliations {
        active {
          id
        }
      }
      affiliations {
        id
      }
    }
  }
`;

export const YourMenuItems = (affiliations: any) => {
  const robotRightsIdsArray = [];
  for (const affiliation of affiliations.affiliations.filter(
    (item: Affiliation) =>
      item.roles.some(
        (role) =>
          role.title === RoleType.Editor || role.title === RoleType.Owner,
      ),
  )) {
    robotRightsIdsArray.push(affiliation.organization.id);
  }
  const editorOrgsString = robotRightsIdsArray.join("+");
  const { data } = useQueryWithSnack(ORG_MENUITEMS_QUERY, {
    variables: {
      filter: {
        ids: robotRightsIdsArray,
      },
    },
    skip: !editorOrgsString,
  });

  const IsViewerOnly = robotRightsIdsArray.length === 0;
  const activeRobotAffs = data?.organizations
    .map((org: Organization) =>
      org.robotAffiliations.filter(
        (item: RobotAffiliation) => item.active !== null,
      ),
    )
    .flat();
  const allRobotAffs = data?.organizations
    .map((org: Organization) => org.robotAffiliations)
    .flat();

  return (
    <>
      <MenuTitle title={"ALL"} orgId={"ALL"} hideSettings={true} />
      <NavLink
        to={`fm/all/${affiliations.affiliations.map((item: Affiliation) => item.organization.id).join("+")}/disinfections`}
        style={{
          textDecoration: "none",
        }}
      >
        {({ isActive }) => {
          return (
            <MenuItem
              hideCount
              isActive={isActive}
              value="Disinfections"
              icon={<IoGridOutline style={{ height: 20, width: 20 }} />}
            />
          );
        }}
      </NavLink>
      {IsViewerOnly ? null : (
        <NavLink
          to={`fm/all/${editorOrgsString}/robots`}
          style={{
            textDecoration: "none",
            pointerEvents: activeRobotAffs?.length === 0 ? "none" : "auto",
          }}
        >
          {({ isActive }) => {
            return (
              <MenuItem
                isActive={isActive}
                value="Robots"
                icon={<UVDRobotIcon />}
                count={activeRobotAffs?.length || 0}
                disabled={allRobotAffs?.length === 0}
              />
            );
          }}
        </NavLink>
      )}
    </>
  );
};
